import React from 'react'
import styles from './Footer.module.css'

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.col}>
          <h4>AstmaAllergi</h4>
          <p>Din personlige assistent til et bedre liv med astma og allergi.</p>
        </div>

        <div className={styles.col}>
          <h4>Produkt</h4>
          <ul>
            <li>Funktioner</li>
            <li>Premium</li>
            <li>Priser</li>
          </ul>
        </div>

        <div className={styles.col}>
          <h4>Support</h4>
          <ul>
            <li>Videncenter</li>
            <li>Kontakt</li>
            <li>Privatliv</li>
          </ul>
        </div>

        <div className={styles.colRight}>
          <p>© {new Date().getFullYear()} AstmaAllergi — Alle rettigheder forbeholdes.</p>
        </div>
      </div>
    </footer>
  )
}
